var styles = {"box":"CategoryList_box_humkq_1","header":"CategoryList_header_humkq_6","title":"CategoryList_title_humkq_19","body":"CategoryList_body_humkq_27","load-more":"CategoryList_load-more_humkq_43"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
